import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from 'react-hook-form';
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Steps } from "primereact/steps";
import { MenuItem } from "primereact/menuitem";
import getViaCep from "../../service/getViaCep";
import { carregarFranquias } from "../../hooks/useFranquias";

export default function RepresentanteCadastrar({ representante, onClose, onSave, msgs }: { representante: any, onClose: () => void, onSave: (representante: any) => void, msgs: any }) {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedBanco, setSelectedBanco] = useState(representante.banco || null);
  const [tipoConta, setTipoConta] = useState(representante.tipoConta || null);
  const [franquias, setFranquias] = useState<any>([]);
  const [selectedFranquias, setSelectedFranquias] = useState<any>([]);

  const itemRenderer = (item: MenuItem, itemIndex: number) => {
    const isActiveItem = activeIndex === itemIndex;
    const backgroundColor = isActiveItem ? '#183462' : 'var(--surface-b)';
    const textColor = isActiveItem ? '#4b5563' : 'var(--text-color-secondary)';

    return (
      <div className="flex-consulta flex-column align-items-center">
        <span
          className="inline-flex align-items-center justify-content-center border-circle border-primary border-1 h-3rem w-3rem z-1 cursor-pointer"
          style={{ backgroundColor: backgroundColor, color: isActiveItem ? 'white' : '#183462' }}
          onClick={() => setActiveIndex(itemIndex)}
        >
          <i className={`${item.icon} text-xl`} />
        </span>
        <span className="mt-2" style={{ fontSize: '1rem', color: textColor, fontWeight: isActiveItem ? '700' : 'normal' }}>
          {item.label}
        </span>
      </div>
    );
  };

  const items: MenuItem[] = [
    {
      label: 'Identificação',
      icon: 'pi pi-id-card',
      template: (item) => itemRenderer(item, 0)
    },
    {
      label: 'Endereço',
      icon: 'pi pi-map-marker',
      template: (item) => itemRenderer(item, 1)
    },
    {
      label: 'Dados bancários',
      icon: 'pi pi-dollar',
      template: (item) => itemRenderer(item, 2)
    }
  ];

  const bancos = [
    { name: 'Selecione', code: null },
    { name: 'Banco do Brasil', code: '001' },
    { name: 'Bradesco', code: '237' },
    { name: 'Itaú', code: '341' },
    { name: 'Santander', code: '033' },
    { name: 'Caixa Econômica', code: '104' },
    { name: 'Safra', code: '422' },
    { name: 'BTG Pactual', code: '208' },
    { name: 'Sicoob', code: '756' },
    { name: 'Banrisul', code: '041' },
    { name: 'Daycoval', code: '400' },
    { name: 'Pan', code: '611' },
    { name: 'Original', code: '212' },
    { name: 'BS2', code: '218' }
  ];

  const tipoContaOptions = [
    { name: 'Selecione', code: null },
    { name: 'Conta Corrente', code: 'CORRENTE' },
    { name: 'Conta Poupança', code: 'POUPANCA' }
  ];

  const defaultValues = {
    documento: '',
    nome: '',
    telefone: '',
    email: '',
    cep: '',
    logradouro: '',
    numeroEndereco: '',
    complemento: '',
    bairro: '',
    cidade: '',
    uf: '',
    agencia: '',
    conta: '',
    titular: '',
    chavePix: '',
    percentualComissao: null as number | null,
    limiteConsultaMensal: null as number | null
  };
  defaultValues.documento = representante.documento ? maskCpfCnpj(representante.documento.toString()) : ''
  defaultValues.nome = representante.nome ? representante.nome.toString() : ''
  defaultValues.telefone = representante.telefone ? representante.telefone.toString() : ''
  defaultValues.email = representante.email ? representante.email.toString() : ''
  defaultValues.cep = representante.cep ? representante.cep.toString() : ''
  defaultValues.logradouro = representante.logradouro ? representante.logradouro.toString() : ''
  defaultValues.numeroEndereco = representante.numeroEndereco ? representante.numeroEndereco.toString() : ''
  defaultValues.complemento = representante.complemento ? representante.complemento.toString() : ''
  defaultValues.bairro = representante.bairro ? representante.bairro.toString() : ''
  defaultValues.cidade = representante.cidade ? representante.cidade.toString() : ''
  defaultValues.uf = representante.uf ? representante.uf.toString() : ''
  defaultValues.agencia = representante.agencia ? representante.agencia.toString() : ''
  defaultValues.conta = representante.conta ? representante.conta.toString() : ''
  defaultValues.titular = representante.titular ? representante.titular.toString() : ''
  defaultValues.chavePix = representante.chavePix ? representante.chavePix.toString() : ''
  defaultValues.percentualComissao = representante.percentualComissao != null ? Number(representante.percentualComissao) : null
  defaultValues.limiteConsultaMensal = representante.limiteConsultaMensal != null ? Number(representante.limiteConsultaMensal) : null

  function cnpj(v: string) {
    v = v.replace(/\D/g, "")
    v = v.replace(/^(\d{2})(\d)/, "$1.$2")
    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    v = v.replace(/\.(\d{3})(\d)/, ".$1/$2")
    v = v.replace(/(\d{4})(\d)/, "$1-$2")
    return v
  }

  function cpf(v: string) {
    v = v.replace(/\D/g, "")
    v = v.replace(/(\d{3})(\d)/, "$1.$2")
    v = v.replace(/(\d{3})(\d)/, "$1.$2")
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    return v
  }

  function maskCpfCnpj(input: string) {
    if (input.length > 14) {
      return cnpj(input)
    }
    else {
      return cpf(input)
    }
  }

  function maskTelefone(v: string) {
    v = v.replace(/\D/g, "").slice(0, 11)
    v = v.replace(/^(\d{2})(\d)/, "($1) $2")
    if (v.length > 13) {
      v = v.replace(/(\d{5})(\d{1,4})$/, "$1-$2")
    } else {
      v = v.replace(/(\d{4})(\d{1,4})$/, "$1-$2")
    }
    return v
  }

  const verifyCnpj = (cnpj: string) => {
    cnpj = cnpj.replace(/[^\d]+/g, '');
    if (cnpj === '') return false;
    if (cnpj.length !== 14) return false;
    if (cnpj === "00000000000000" || cnpj === "11111111111111" || cnpj === "22222222222222" ||
      cnpj === "33333333333333" || cnpj === "44444444444444" || cnpj === "55555555555555" ||
      cnpj === "66666666666666" || cnpj === "77777777777777" || cnpj === "88888888888888" ||
      cnpj === "99999999999999")
      return false;

    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0, tamanho) + '';
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2)
        pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado !== parseInt(digitos.charAt(0)))
      return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
      if (pos < 2)
        pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado !== parseInt(digitos.charAt(1)))
      return false;

    return true;
  }

  const verifyCPF = (strCPF: string) => {
    strCPF = strCPF.replaceAll('.', '').replace('-', '')
    let Soma;
    let Resto;
    Soma = 0;
    if (strCPF === "00000000000") return false;
    if (strCPF === "11111111111") return false;
    if (strCPF === "22222222222") return false;
    if (strCPF === "33333333333") return false;
    if (strCPF === "44444444444") return false;
    if (strCPF === "55555555555") return false;
    if (strCPF === "66666666666") return false;
    if (strCPF === "77777777777") return false;
    if (strCPF === "88888888888") return false;
    if (strCPF === "99999999999") return false;

    for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(10, 11))) return false;
    return true;
  }

  const validDocument = (document: string) => {
    const onlyDigits = document.replace(/\D/g, '');
    let valid = onlyDigits.length === 11 ? verifyCPF(onlyDigits) : verifyCnpj(onlyDigits);
    if (valid) {
      msgs.current?.clear();
    }
    else {
      msgs.current?.clear();
      msgs.current?.show([
        { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Documento inválido', closable: false }
      ]);
    }
  }

  const {
    control,
    formState: { errors },
    setValue,
    handleSubmit
  } = useForm({ defaultValues });

  const buscarCep = (cep: string) => {
    if (cep.length === 8) {
      getViaCep(cep).then((data) => {
        if (data) {
          setValue('bairro', data.bairro)
          setValue('cidade', data.localidade)
          setValue('uf', data.uf)
          setValue('logradouro', data.logradouro)
        }
      }).catch((erro) => console.error(erro))
    }
  }

  const getFormErrorMessage = (name: string) => {
    type ObjectKey = keyof typeof errors;
    const error = errors[Object.keys(errors).find(k => k === name) as ObjectKey]
    return error ? <small className="p-error">{error.message}</small> : <small className="p-error">&nbsp;</small>;
  };

  const getFieldLabel = (fieldName: string) => {
    const labels: { [key: string]: string } = {
      'documento': 'Documento',
      'nome': 'Nome',
      'cep': 'CEP',
      'logradouro': 'Logradouro',
      'numeroEndereco': 'Número',
      'bairro': 'Bairro',
      'cidade': 'Cidade',
      'uf': 'UF'
    };
    return labels[fieldName] || fieldName;
  };

  const validateCurrentStep = () => {
    const formValues = control._formValues;

    switch (activeIndex) {
      case 0: { // Identificação
        const requiredFields = ['nome', 'documento'];
        for (const field of requiredFields) {
          const value = formValues[field];
          if (!value || (typeof value === 'string' && value.trim() === '')) {
            msgs.current?.clear();
            msgs.current?.show([
              {
                sticky: false, life: 5000, severity: 'warn', summary: 'Campos obrigatórios',
                detail: `Por favor, preencha todos os campos obrigatórios: ${requiredFields.map(f => getFieldLabel(f)).join(', ')}`,
                closable: true
              }
            ]);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }
        }

        const onlyDigits = formValues.documento.replace(/\D/g, '');
        const docValid = onlyDigits.length === 11 ? verifyCPF(onlyDigits) : verifyCnpj(onlyDigits);
        if (!docValid) {
          msgs.current?.clear();
          msgs.current?.show([
            { sticky: false, life: 5000, severity: 'error', summary: 'Documento inválido', detail: 'Por favor, insira um documento válido', closable: true }
          ]);
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }

        const percentualComissao = formValues.percentualComissao;
        if (percentualComissao == null || percentualComissao <= 0) {
          msgs.current?.clear();
          msgs.current?.show([
            { sticky: false, life: 5000, severity: 'warn', summary: 'Percentual Comissão', detail: 'Percentual Comissão é obrigatório e deve ser maior que 0', closable: true }
          ]);
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return false;
        }
        return true;
      }

      case 1: { // Endereço
        const requiredFields = ['cep', 'logradouro', 'numeroEndereco', 'bairro', 'cidade', 'uf'];
        for (const field of requiredFields) {
          const value = formValues[field];
          if (!value || (typeof value === 'string' && value.trim() === '')) {
            msgs.current?.clear();
            msgs.current?.show([
              {
                sticky: false, life: 5000, severity: 'warn', summary: 'Campos obrigatórios',
                detail: `Por favor, preencha todos os campos de endereço: ${requiredFields.map(f => getFieldLabel(f)).join(', ')}`,
                closable: true
              }
            ]);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
          }
        }
        return true;
      }

      default:
        return true;
    }
  };

  const nextStep = () => {
    if (activeIndex < 2) {
      if (validateCurrentStep()) {
        setActiveIndex(activeIndex + 1);
      }
    }
  };

  const prevStep = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const onSubmit = (data: any) => {
    if (!validateCurrentStep()) {
      return;
    }
    save(data);
  };

  const save = (data: any) => {
    const novoRepresentante = {
      id: representante.id ? representante.id : undefined,
      documento: data.documento.replaceAll('.', '').replaceAll('-', '').replaceAll('/', ''),
      nome: data.nome,
      telefone: data.telefone,
      email: data.email,
      franquias: selectedFranquias.map((f: any) => ({ id: f.id })),
      cep: data.cep,
      logradouro: data.logradouro,
      numeroEndereco: data.numeroEndereco,
      complemento: data.complemento,
      bairro: data.bairro,
      cidade: data.cidade,
      uf: data.uf,
      banco: selectedBanco ? (selectedBanco.code ? selectedBanco.code : selectedBanco) : null,
      agencia: data.agencia,
      conta: data.conta,
      tipoConta: tipoConta ? (tipoConta.code ? tipoConta.code : tipoConta) : null,
      titular: data.titular,
      chavePix: data.chavePix,
      percentualComissao: data.percentualComissao,
      limiteConsultaMensal: data.limiteConsultaMensal
    }
    window.scrollTo(0, 0);
    onSave(novoRepresentante);
  }

  useEffect(() => {
    if (representante.banco) {
      const banco = bancos.find((b) => b.code === representante.banco);
      if (banco) setSelectedBanco(banco);
    }
    if (representante.tipoConta) {
      const tc = tipoContaOptions.find((t) => t.code === representante.tipoConta);
      if (tc) setTipoConta(tc);
    }

    carregarFranquias().then((lista) => {
      setFranquias(lista);
      // Na edição os ids são dinâmicos, então o bind das selecionadas é feito pelo nome
      if (representante.franquias && representante.franquias.length > 0) {
        const nomesSelecionados = representante.franquias.map((f: any) => f.nome);
        const selecionadas = lista.filter((f: any) => nomesSelecionados.includes(f.nome));
        setSelectedFranquias(selecionadas);
      }
    }).catch((erro) => console.error(erro))
  }, [])

  const renderIdentificacaoStep = () => (
    <div>
      <div className="mb-4">
        <h4 className="font-semibold mb-3 border-bottom pb-2" style={{ color: '#4b5563', fontSize: '1.25rem' }}>Identificação</h4>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <Controller
              name="nome"
              control={control}
              rules={{ required: 'Nome é Obrigatório' }}
              render={({ field, fieldState }) => (
                <>
                  <span>
                    <div>
                      <label htmlFor="nome" className="font-bold block mb-2 required">{t('nome')} </label>
                      <InputText style={{ width: '100%' }} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col">
            <Controller
              name="documento"
              control={control}
              rules={{ required: 'Documento é Obrigatório' }}
              render={({ field, fieldState }) => (
                <>
                  <span>
                    <div>
                      <label htmlFor="documento" className="font-bold block mb-2 required">{t('documento')} </label>
                      <InputText
                        maxLength={18}
                        max={18}
                        onKeyUp={() => { field.onChange(maskCpfCnpj(field.value)) }}
                        style={{ width: '100%' }}
                        id={field.name}
                        value={field.value}
                        className={classNames({ 'p-invalid': fieldState.error })}
                        onBlur={(e) => validDocument(e.target.value)}
                        onChange={(e) => field.onChange(e.target.value)}
                        disabled={!!(representante.id)}
                      />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div>
              <label className="font-bold block mb-2">{t('franquias')}</label>
              <MultiSelect
                style={{ width: '100%' }}
                value={selectedFranquias}
                onChange={(e) => setSelectedFranquias(e.value)}
                options={franquias}
                optionLabel="nome"
                placeholder="Selecione as franquias"
                display="chip"
                filter
                className="w-full"
              />
            </div>
          </div>
          <div className="col">
            <Controller
              name="percentualComissao"
              control={control}
              rules={{
                required: 'Percentual Comissão é Obrigatório',
                validate: (value) => (value != null && value > 0) || 'Percentual Comissão deve ser maior que 0'
              }}
              render={({ field, fieldState }) => (
                <>
                  <span>
                    <div>
                      <label htmlFor="percentualComissao" className="font-bold block mb-2 required">{t('percentualComissao')} </label>
                      <InputNumber
                        style={{ width: '100%' }}
                        id={field.name}
                        value={field.value}
                        className={classNames({ 'p-invalid': fieldState.error })}
                        onValueChange={(e) => field.onChange(e.value ?? null)}
                        mode="decimal" minFractionDigits={2} maxFractionDigits={2} min={0} max={100} suffix=" %" locale="pt-BR"
                      />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <Controller
              name="telefone"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <span>
                    <div>
                      <label htmlFor="telefone" className="font-bold block mb-2">{t('telefone')} </label>
                      <InputText
                        style={{ width: '100%' }}
                        id={field.name}
                        value={field.value}
                        className={classNames({ 'p-invalid': fieldState.error })}
                        onChange={(e) => field.onChange(maskTelefone(e.target.value))}
                      />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col">
            <Controller
              name="email"
              control={control}
              rules={{
                pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: 'E-mail inválido' }
              }}
              render={({ field, fieldState }) => (
                <>
                  <span>
                    <div>
                      <label htmlFor="email" className="font-bold block mb-2">{t('email')} </label>
                      <InputText
                        style={{ width: '100%' }}
                        id={field.name}
                        value={field.value}
                        className={classNames({ 'p-invalid': fieldState.error })}
                        onChange={(e) => field.onChange(e.target.value)}
                      />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <Controller
              name="limiteConsultaMensal"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <span>
                    <div>
                      <label htmlFor="limiteConsultaMensal" className="font-bold block mb-2">{t('limiteConsultaMensal')} </label>
                      <InputNumber
                        style={{ width: '100%' }}
                        id={field.name}
                        value={field.value}
                        className={classNames({ 'p-invalid': fieldState.error })}
                        onValueChange={(e) => field.onChange(e.value ?? null)}
                        mode="decimal" maxFractionDigits={0} min={0} useGrouping={false} locale="pt-BR"
                        placeholder="Sem limite"
                      />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col"></div>
        </div>
      </div>
    </div>
  );

  const renderEnderecoStep = () => (
    <div>
      <div className="mb-4">
        <h4 className="font-semibold mb-3 border-bottom pb-2" style={{ color: '#4b5563', fontWeight: 800, fontSize: '1.25rem' }}>Endereço</h4>
        <div className="grid">
          <div className="col">
            <Controller
              name="cep"
              control={control}
              rules={{ required: 'CEP é Obrigatório' }}
              render={({ field, fieldState }) => (
                <>
                  <span>
                    <div>
                      <label htmlFor="cep" className="font-bold block mb-2 required">{t('cep')} </label>
                      <InputText
                        style={{ width: '100%' }}
                        id={field.name}
                        value={field.value}
                        className={classNames({ 'p-invalid': fieldState.error })}
                        onChange={(e) => {
                          const sanitizedValue = e.target.value.replace(/\D/g, '').slice(0, 8);
                          field.onChange(sanitizedValue);
                          buscarCep(sanitizedValue);
                        }}
                        onKeyPress={(e) => { if (!/[0-9]/.test(e.key)) { e.preventDefault(); } }}
                      />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col">
            <Controller
              name="logradouro"
              control={control}
              rules={{ required: 'Logradouro é Obrigatório' }}
              render={({ field, fieldState }) => (
                <>
                  <span>
                    <div>
                      <label htmlFor="logradouro" className="font-bold block mb-2 required">{t('logradouro')} </label>
                      <InputText style={{ width: '100%' }} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col">
            <Controller
              name="numeroEndereco"
              control={control}
              rules={{ required: 'Número é Obrigatório' }}
              render={({ field, fieldState }) => (
                <>
                  <span>
                    <div>
                      <label htmlFor="numeroEndereco" className="font-bold block mb-2 required">{t('numero')} </label>
                      <InputText style={{ width: '100%' }} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col">
            <Controller
              name="bairro"
              control={control}
              rules={{ required: 'Bairro é Obrigatório' }}
              render={({ field, fieldState }) => (
                <>
                  <span>
                    <div>
                      <label htmlFor="bairro" className="font-bold block mb-2 required">{t('bairro')} </label>
                      <InputText style={{ width: '100%' }} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <Controller
              name="complemento"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <span>
                    <div>
                      <label htmlFor="complemento" className="font-bold block mb-2">{t('complemento')} </label>
                      <InputText style={{ width: '100%' }} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col">
            <Controller
              name="cidade"
              control={control}
              rules={{ required: 'Cidade é Obrigatório' }}
              render={({ field, fieldState }) => (
                <>
                  <span>
                    <div>
                      <label htmlFor="cidade" className="font-bold block mb-2 required">{t('cidade')} </label>
                      <InputText style={{ width: '100%' }} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
          <div className="col">
            <Controller
              name="uf"
              control={control}
              rules={{ required: 'UF é Obrigatório' }}
              render={({ field, fieldState }) => (
                <>
                  <span>
                    <div>
                      <label htmlFor="uf" className="font-bold block mb-2 required">{t('uf')} </label>
                      <InputText style={{ width: '100%' }} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                    </div>
                  </span>
                  {getFormErrorMessage(field.name)}
                </>
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );

  const renderDadosBancariosStep = () => (
    <div>
      <div className="mb-4">
        <h4 className="font-semibold mb-3 border-bottom pb-2" style={{ color: '#4b5563', fontWeight: 800, fontSize: '1.25rem' }}>Dados Bancários</h4>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div>
              <label className="font-bold block mb-2">{t('banco')}</label>
              <Dropdown style={{ width: '100%' }} value={selectedBanco} onChange={(e) => setSelectedBanco(e.value)} options={bancos} optionLabel="name"
                placeholder="Selecione" className="w-full md:w-14rem" />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div>
              <label className="font-bold block mb-2">{t('agencia')}</label>
              <Controller
                name="agencia"
                control={control}
                render={({ field }) => (
                  <InputText style={{ width: '100%' }} id={field.name} value={field.value} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div>
              <label className="font-bold block mb-2">{t('conta')}</label>
              <Controller
                name="conta"
                control={control}
                render={({ field }) => (
                  <InputText style={{ width: '100%' }} id={field.name} value={field.value} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div>
              <label className="font-bold block mb-2">{t('tipoConta')}</label>
              <Dropdown style={{ width: '100%' }} value={tipoConta} onChange={(e) => setTipoConta(e.value)} options={tipoContaOptions} optionLabel="name"
                placeholder="Selecione" className="w-full md:w-14rem" />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div>
              <label className="font-bold block mb-2">{t('titular')}</label>
              <Controller
                name="titular"
                control={control}
                render={({ field }) => (
                  <InputText style={{ width: '100%' }} id={field.name} value={field.value} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div>
              <label className="font-bold block mb-2">{t('chavePix')}</label>
              <Controller
                name="chavePix"
                control={control}
                render={({ field }) => (
                  <InputText style={{ width: '100%' }} id={field.name} value={field.value} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderStepContent = () => {
    switch (activeIndex) {
      case 0:
        return renderIdentificacaoStep();
      case 1:
        return renderEnderecoStep();
      case 2:
        return renderDadosBancariosStep();
      default:
        return renderIdentificacaoStep();
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-2" autoComplete="off">
      <div className="card">
        <Steps model={items} activeIndex={activeIndex} />
      </div>

      <div className="card" key={activeIndex}>
        {renderStepContent()}
      </div>
      <br></br>
      <br></br>

      <div style={{ display: "flex", justifyContent: "space-between", paddingTop: "1rem" }} className=" flex">
        <div>
          {activeIndex > 0 && (
            <Button
              type="button"
              label="Anterior"
              icon="pi pi-chevron-left"
              onClick={prevStep}
              style={{ marginRight: "1rem", backgroundColor: 'white', color: '#183462', borderColor: '#183462' }}
            />
          )}
        </div>
        <div className="flex-consulta" style={{ gap: '0.5rem' }}>
          <Button label="Fechar" severity="secondary" outlined onClick={onClose} />
          {activeIndex === 2 && (
            <Button style={{ marginRight: "1rem", backgroundColor: '#183462', borderColor: '#183462' }} label="Salvar" type="submit" />
          )}
          {activeIndex < 2 && (
            <Button
              type="button"
              label="Próximo"
              icon="pi pi-chevron-right"
              iconPos="right"
              onClick={nextStep}
              style={{ backgroundColor: '#183462', borderColor: '#183462' }}
            />
          )}
        </div>
      </div>
    </form>
  )
}
